import { createFileRoute } from '@tanstack/react-router';

import { CustomersImporterPage } from '@/areas/customers/Customers/CustomersImporterPage';
import { canImportCustomers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/customers/importer')({
    staticData: { access: { permissions: canImportCustomers }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <CustomersImporterPage />;
}
